/**
 * Halftone Pulse mark, as `[path, brand fill]` per dot, from the 28×28 `logo_standalone_color.svg`.
 * Exported for surfaces that draw the mark without React, such as a PDF.
 */
export const PULSE_MARK_DOTS = [
  [
    'M8.49898 2.94995C9.2998 2.94995 9.94898 2.30076 9.94898 1.49995C9.94898 0.699136 9.2998 0.0499487 8.49898 0.0499487C7.69817 0.0499487 7.04898 0.699136 7.04898 1.49995C7.04898 2.30076 7.69817 2.94995 8.49898 2.94995Z',
    '#A5B85F',
  ],
  [
    'M13.499 2.98995C14.3219 2.98995 14.989 2.32285 14.989 1.49995C14.989 0.677045 14.3219 0.00994873 13.499 0.00994873C12.6761 0.00994873 12.009 0.677045 12.009 1.49995C12.009 2.32285 12.6761 2.98995 13.499 2.98995Z',
    '#66B7CC',
  ],
  [
    'M18.499 2.85995C19.2501 2.85995 19.859 2.25106 19.859 1.49995C19.859 0.748842 19.2501 0.139949 18.499 0.139949C17.7479 0.139949 17.139 0.748842 17.139 1.49995C17.139 2.25106 17.7479 2.85995 18.499 2.85995Z',
    '#5699CC',
  ],
  [
    'M3.49898 8.03995C4.3495 8.03995 5.03898 7.35047 5.03898 6.49995C5.03898 5.64943 4.3495 4.95995 3.49898 4.95995C2.64847 4.95995 1.95898 5.64943 1.95898 6.49995C1.95898 7.35047 2.64847 8.03995 3.49898 8.03995Z',
    '#ECB019',
  ],
  [
    'M8.49898 8.30995C9.49862 8.30995 10.309 7.49958 10.309 6.49995C10.309 5.50031 9.49862 4.68995 8.49898 4.68995C7.49935 4.68995 6.68898 5.50031 6.68898 6.49995C6.68898 7.49958 7.49935 8.30995 8.49898 8.30995Z',
    '#FFAB05',
  ],
  [
    'M13.499 8.37995C14.5373 8.37995 15.379 7.53824 15.379 6.49995C15.379 5.46165 14.5373 4.61995 13.499 4.61995C12.4607 4.61995 11.619 5.46165 11.619 6.49995C11.619 7.53824 12.4607 8.37995 13.499 8.37995Z',
    '#C9C353',
  ],
  [
    'M18.499 8.18995C19.4323 8.18995 20.189 7.43331 20.189 6.49995C20.189 5.56659 19.4323 4.80995 18.499 4.80995C17.5656 4.80995 16.809 5.56659 16.809 6.49995C16.809 7.43331 17.5656 8.18995 18.499 8.18995Z',
    '#66B7CC',
  ],
  [
    'M23.499 7.85995C24.2501 7.85995 24.859 7.25106 24.859 6.49995C24.859 5.74884 24.2501 5.13995 23.499 5.13995C22.7479 5.13995 22.139 5.74884 22.139 6.49995C22.139 7.25106 22.7479 7.85995 23.499 7.85995Z',
    '#5699CC',
  ],
  [
    'M3.49898 13.04C4.3495 13.04 5.03898 12.3505 5.03898 11.5C5.03898 10.6495 4.3495 9.95999 3.49898 9.95999C2.64847 9.95999 1.95898 10.6495 1.95898 11.5C1.95898 12.3505 2.64847 13.04 3.49898 13.04Z',
    '#FEA012',
  ],
  [
    'M8.49885 13.3799C9.53714 13.3799 10.3788 12.5381 10.3788 11.4999C10.3788 10.4616 9.53714 9.61985 8.49885 9.61985C7.46055 9.61985 6.61885 10.4616 6.61885 11.4999C6.61885 12.5381 7.46055 13.3799 8.49885 13.3799Z',
    '#FFAB05',
  ],
  [
    'M13.4993 13.3799C14.5376 13.3799 15.3793 12.5381 15.3793 11.4999C15.3793 10.4616 14.5376 9.61985 13.4993 9.61985C12.461 9.61985 11.6193 10.4616 11.6193 11.4999C11.6193 12.5381 12.461 13.3799 13.4993 13.3799Z',
    '#FFAB05',
  ],
  [
    'M18.499 13.3799C19.5373 13.3799 20.379 12.5382 20.379 11.5C20.379 10.4617 19.5373 9.61995 18.499 9.61995C17.4607 9.61995 16.619 10.4617 16.619 11.5C16.619 12.5382 17.4607 13.3799 18.499 13.3799Z',
    '#C9C353',
  ],
  [
    'M23.499 12.9899C24.3219 12.9899 24.989 12.3229 24.989 11.5C24.989 10.677 24.3219 10.0099 23.499 10.0099C22.6761 10.0099 22.009 10.677 22.009 11.5C22.009 12.3229 22.6761 12.9899 23.499 12.9899Z',
    '#66B7CC',
  ],
  [
    'M3.49904 18.04C4.34956 18.04 5.03904 17.3506 5.03904 16.5C5.03904 15.6495 4.34956 14.96 3.49904 14.96C2.64852 14.96 1.95904 15.6495 1.95904 16.5C1.95904 17.3506 2.64852 18.04 3.49904 18.04Z',
    '#FD882E',
  ],
  [
    'M8.4992 18.38C9.53749 18.38 10.3792 17.5383 10.3792 16.5C10.3792 15.4617 9.53749 14.62 8.4992 14.62C7.4609 14.62 6.6192 15.4617 6.6192 16.5C6.6192 17.5383 7.4609 18.38 8.4992 18.38Z',
    '#FE961E',
  ],
  [
    'M13.4988 18.3799C14.5371 18.3799 15.3788 17.5381 15.3788 16.4999C15.3788 15.4616 14.5371 14.6199 13.4988 14.6199C12.4606 14.6199 11.6188 15.4616 11.6188 16.4999C11.6188 17.5381 12.4606 18.3799 13.4988 18.3799Z',
    '#FFAB05',
  ],
  [
    'M18.4991 18.1999C19.438 18.1999 20.1991 17.4388 20.1991 16.4999C20.1991 15.561 19.438 14.7999 18.4991 14.7999C17.5602 14.7999 16.7991 15.561 16.7991 16.4999C16.7991 17.4388 17.5602 18.1999 18.4991 18.1999Z',
    '#FFAB05',
  ],
  [
    'M23.499 17.45C24.0237 17.45 24.449 17.0247 24.449 16.5C24.449 15.9753 24.0237 15.55 23.499 15.55C22.9743 15.55 22.549 15.9753 22.549 16.5C22.549 17.0247 22.9743 17.45 23.499 17.45Z',
    '#A5B85F',
  ],
  [
    'M3.49898 22.9099C4.27771 22.9099 4.90898 22.2787 4.90898 21.5C4.90898 20.7212 4.27771 20.09 3.49898 20.09C2.72026 20.09 2.08898 20.7212 2.08898 21.5C2.08898 22.2787 2.72026 22.9099 3.49898 22.9099Z',
    '#FB704A',
  ],
  [
    'M8.49898 23.14C9.40473 23.14 10.139 22.4057 10.139 21.5C10.139 20.5942 9.40473 19.8599 8.49898 19.8599C7.59324 19.8599 6.85898 20.5942 6.85898 21.5C6.85898 22.4057 7.59324 23.14 8.49898 23.14Z',
    '#FC8334',
  ],
  [
    'M13.4991 22.9101C14.2778 22.9101 14.9091 22.2788 14.9091 21.5001C14.9091 20.7214 14.2778 20.0901 13.4991 20.0901C12.7204 20.0901 12.0891 20.7214 12.0891 21.5001C12.0891 22.2788 12.7204 22.9101 13.4991 22.9101Z',
    '#FE9C17',
  ],
  [
    'M18.4991 22.4498C19.0238 22.4498 19.4491 22.0245 19.4491 21.4998C19.4491 20.9752 19.0238 20.5498 18.4991 20.5498C17.9744 20.5498 17.5491 20.9752 17.5491 21.4998C17.5491 22.0245 17.9744 22.4498 18.4991 22.4498Z',
    '#EEB016',
  ],
  [
    'M8.65045 27.7598C9.34633 27.7598 9.91045 27.1957 9.91045 26.4998C9.91045 25.804 9.34633 25.2398 8.65045 25.2398C7.95457 25.2398 7.39045 25.804 7.39045 26.4998C7.39045 27.1957 7.95457 27.7598 8.65045 27.7598Z',
    '#FC7643',
  ],
  [
    'M3.65908 27.7599C4.35496 27.7599 4.91908 27.1958 4.91908 26.4999C4.91908 25.8041 4.35496 25.2399 3.65908 25.2399C2.9632 25.2399 2.39908 25.8041 2.39908 26.4999C2.39908 27.1958 2.9632 27.7599 3.65908 27.7599Z',
    '#FA5B62',
  ],
  [
    'M13.4993 27.6C14.1068 27.6 14.5993 27.1075 14.5993 26.5C14.5993 25.8925 14.1068 25.4 13.4993 25.4C12.8918 25.4 12.3993 25.8925 12.3993 26.5C12.3993 27.1075 12.8918 27.6 13.4993 27.6Z',
    '#FD9222',
  ],
] as const;

interface PulseMarkProps {
  /** Edge length in px of the square mark. */
  size?: number;
}

/**
 * The standalone Pulse mark (`logo_standalone_color.svg`), drawn on a 28×28 grid and scaled to
 * `size` px square.
 */
export const PulseMark = ({ size = 16 }: PulseMarkProps) => (
  <svg
    aria-hidden
    fill="none"
    height={size}
    viewBox="0 0 28 28"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    {PULSE_MARK_DOTS.map(([d, dotFill]) => (
      <path key={d} d={d} fill={dotFill} />
    ))}
  </svg>
);
